import { composedFetch, getWaitingListURL } from './helpers'
import { errorIfInvalidResponse } from './errors'

type WaitingListEntry = {
  email: string
}

export const addToWaitingList = async (waiting_list_entry: WaitingListEntry) => {
  const response = await composedFetch('POST', getWaitingListURL(), null, waiting_list_entry)
  await errorIfInvalidResponse(response)
  return await response.json()
}
